var _circle, _circle2, _circle3, _circle4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 48,
    fill: "url(#paint0_radial_188_925)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 58.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 99,
    cy: 99,
    r: 76.5,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 99,
    cy: 99,
    r: 98.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 84.7502C96.3766 84.7502 94.25 86.8768 94.25 89.5002V97.4168C94.25 100.04 96.3766 102.167 99 102.167C101.623 102.167 103.75 100.04 103.75 97.4168V89.5002C103.75 86.8768 101.623 84.7502 99 84.7502ZM100.583 111.58V114.042C100.583 114.916 99.8744 115.625 99 115.625C98.1255 115.625 97.4167 114.916 97.4167 114.042V111.58C90.2917 110.792 84.75 104.752 84.75 97.4168C84.75 96.5424 85.4589 95.8335 86.3333 95.8335C87.2078 95.8335 87.9167 96.5424 87.9167 97.4168C87.9167 103.538 92.8788 108.5 99 108.5C105.121 108.5 110.083 103.538 110.083 97.4168C110.083 96.5424 110.792 95.8335 111.667 95.8335C112.541 95.8335 113.25 96.5424 113.25 97.4168C113.25 104.752 107.708 110.792 100.583 111.58ZM99 81.5835C103.372 81.5835 106.917 85.1279 106.917 89.5002V97.4168C106.917 101.789 103.372 105.333 99 105.333C94.6277 105.333 91.0833 101.789 91.0833 97.4168V89.5002C91.0833 85.1279 94.6277 81.5835 99 81.5835Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_188_925",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99 99) rotate(90) scale(48)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D45DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D45DF",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.11bf3c550b826e67d33c9f368f7eafae.svg";
export { ForwardRef as ReactComponent };